<h4 mat-dialog-title><div class="display-flex-row"><div class="warning"><mat-icon>warning</mat-icon></div><div><span>Similar Request Exists</span></div></div></h4>
<mat-dialog-content>
  <p>A similar accrual already exists. Are you sure you wish to continue?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="true" class="yes-btn">Yes</button>
  <button mat-button cdkFocusInitial [mat-dialog-close]="false" class="no-btn">No</button>
</mat-dialog-actions>